<template>
  <div class="w-full h-full font-bold">
    <div class="flex w-screen h-full">
      <side-nav />
    </div>
  </div>
</template>

<script>
import refreshToken from '@/mixins/refreshToken.js'
import logout from '@/mixins/logout.js'
export default {
  mixins: [refreshToken, logout],
  name: 'Main',
  components: {
    SideNav: () => import('@/components/base/SideNav.vue')
  },
  async mounted () {
    this.refreshTokenTimeout()
  }
}
</script>
